import {
	afterNextRender,
	ChangeDetectorRef,
	Directive,
	ElementRef,
	HostListener,
	inject,
	OnDestroy,
} from '@angular/core';

@Directive({
	selector: '[directiveIsEllipsis]',
	exportAs: 'isEllipsis',
})
export class IsEllipsisDirective implements OnDestroy {
	private elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
	private changeDetectorRef = inject(ChangeDetectorRef);

	isEllipsed = false;

	private observer?: ResizeObserver;

	constructor() {
		afterNextRender(() => this.observeResize());
	}

	ngOnDestroy(): void {
		this.observer?.disconnect();
	}

	@HostListener('window:resize')
	onResize() {
		this.checkTruncation();
	}

	private observeResize() {
		this.observer = new ResizeObserver(() => this.checkTruncation());
		this.observer.observe(this.elementRef.nativeElement);
		this.checkTruncation();
		this.changeDetectorRef.markForCheck();
	}

	private checkTruncation() {
		const el = this.elementRef.nativeElement;
		const range = document.createRange();

		range.selectNodeContents(el);

		const rects = range.getClientRects();

		// If more than one rect, the content was visually broken (clamped)
		const isEllipsed = rects.length > 1;

		if (isEllipsed === this.isEllipsed) {
			return;
		}

		this.isEllipsed = isEllipsed;
		this.changeDetectorRef.markForCheck();
	}
}
